// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-box-label {
  font-family: "Poppins" !important;
  font-weight: 600 !important;
  font-size: 0.9vw !important;
  line-height: 100% !important;
  color: #595959 !important;
  margin-bottom: 0.3vw !important;
  outline: none !important;
  text-transform: capitalize;
}

.input-box,
.custom-phone-input {
  background-color: transparent !important;
  border: 0.05vw solid #595959 !important;
  height: 2.3vw;
  border-radius: 0.4vw;
  width: 100% !important;
  padding-left: 1vw !important;
  font-size: 0.8vw !important;
  font-family: "Poppins" !important;
  font-weight: 500 !important;
  line-height: 100% !important;
  color: white !important;
  &:focus {
    outline: none !important;
  }
}

.input-box::placeholder {
  color: #595959;
  font-size: 0.8vw;
  font-family: Poppins;
  font-weight: 500;
}

.error-input-box {
  background-color: transparent !important;
  border: 0.05vw solid #f23d3d !important;
  height: 2.3vw;
  border-radius: 0.4vw;
  width: 100% !important;
  padding-left: 1vw !important;
  font-size: 0.8vw !important;
  font-family: "Poppins" !important;
  font-weight: 500 !important;
  line-height: 100% !important;
  /* margin-bottom: 5px !important;   */
  color: white !important;
  &:focus {
    outline: none !important;
  }
}

.error-input-box::placeholder {
  color: #595959;
  font-size: 0.8vw;
  font-family: Poppins;
  font-weight: 500;
}

.error-message {
  color: #f23d3d !important;
  font-family: "Poppins" !important;
  font-weight: 400 !important;
  font-size: 0.55vw !important;
  line-height: 100% !important;
}

.add-btn {
  height: 1.75vw !important;
  width: 1.75vw !important;
  background-color: transparent;
  border: 0.05vw solid #50c878;
  border-radius: 0.15vw;
  color: #50c878;
  cursor: pointer;
  font-size: 0.75vw;
  /* margin-bottom: 6px; */
  &:hover {
    background-color: #50c8782d;
  }
}

.delete-btn {
  height: 1.75vw !important;
  width: 1.75vw !important;
  background-color: transparent;
  border: 0.05vw solid #f23d3d;
  border-radius: 0.15vw;
  color: #f23d3d;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-bottom: .3vw;  */
  &:hover {
    background-color: #f23d3d3b;
  }
}


.react-phone-input-2 .flag-dropdown {
  background-color: transparent !important;
  border: none !important;
}

.react-phone-input-2 .selected-flag {
  background-color: transparent !important;
}

.react-phone-input-2 .flag {
  box-shadow: none !important;
}

.react-tel-input .form-control {
  font-size: 0.9vw !important;
  font-family: Poppins, sans-serif !important;
  font-weight: 500 !important;
  background-color: transparent !important;
  padding-left: 4vw !important;
  height: 2vw !important;
  color: white !important;
  transform: translateY(-20%);
}

.react-tel-input .flag-dropdown {
  background-color: transparent !important;
}
.react-tel-input {
  border: none;
}

/* .custom-flag-button {
  background-color: transparent !important;
  border: none !important;
  margin-left: 0.4vw;
}

.custom-prefix {
  position: absolute;
  top: 50%;
  left: 1vw;
  transform: translateY(-50%);
  font-size: 0.9vw;
  font-family: Poppins;
  font-weight: 500;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 0.3vw;
  pointer-events: none;
}

.custom-prefix .pipe {
  margin-left: 0.3vw;
  margin-right: 0.3vw;
} */
`, "",{"version":3,"sources":["webpack://./src/features/order_client_details/components/multimobile.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;EAC/B,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;;EAEE,wCAAwC;EACxC,uCAAuC;EACvC,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;EACvB;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;EAC5B,qCAAqC;EACrC,uBAAuB;EACvB;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B;IACE,2BAA2B;EAC7B;AACF;;;AAGA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,2BAA2B;EAC3B,wCAAwC;EACxC,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;GAwBG","sourcesContent":[".input-box-label {\n  font-family: \"Poppins\" !important;\n  font-weight: 600 !important;\n  font-size: 0.9vw !important;\n  line-height: 100% !important;\n  color: #595959 !important;\n  margin-bottom: 0.3vw !important;\n  outline: none !important;\n  text-transform: capitalize;\n}\n\n.input-box,\n.custom-phone-input {\n  background-color: transparent !important;\n  border: 0.05vw solid #595959 !important;\n  height: 2.3vw;\n  border-radius: 0.4vw;\n  width: 100% !important;\n  padding-left: 1vw !important;\n  font-size: 0.8vw !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n  line-height: 100% !important;\n  color: white !important;\n  &:focus {\n    outline: none !important;\n  }\n}\n\n.input-box::placeholder {\n  color: #595959;\n  font-size: 0.8vw;\n  font-family: Poppins;\n  font-weight: 500;\n}\n\n.error-input-box {\n  background-color: transparent !important;\n  border: 0.05vw solid #f23d3d !important;\n  height: 2.3vw;\n  border-radius: 0.4vw;\n  width: 100% !important;\n  padding-left: 1vw !important;\n  font-size: 0.8vw !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n  line-height: 100% !important;\n  /* margin-bottom: 5px !important;   */\n  color: white !important;\n  &:focus {\n    outline: none !important;\n  }\n}\n\n.error-input-box::placeholder {\n  color: #595959;\n  font-size: 0.8vw;\n  font-family: Poppins;\n  font-weight: 500;\n}\n\n.error-message {\n  color: #f23d3d !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 400 !important;\n  font-size: 0.55vw !important;\n  line-height: 100% !important;\n}\n\n.add-btn {\n  height: 1.75vw !important;\n  width: 1.75vw !important;\n  background-color: transparent;\n  border: 0.05vw solid #50c878;\n  border-radius: 0.15vw;\n  color: #50c878;\n  cursor: pointer;\n  font-size: 0.75vw;\n  /* margin-bottom: 6px; */\n  &:hover {\n    background-color: #50c8782d;\n  }\n}\n\n.delete-btn {\n  height: 1.75vw !important;\n  width: 1.75vw !important;\n  background-color: transparent;\n  border: 0.05vw solid #f23d3d;\n  border-radius: 0.15vw;\n  color: #f23d3d;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* margin-bottom: .3vw;  */\n  &:hover {\n    background-color: #f23d3d3b;\n  }\n}\n\n\n.react-phone-input-2 .flag-dropdown {\n  background-color: transparent !important;\n  border: none !important;\n}\n\n.react-phone-input-2 .selected-flag {\n  background-color: transparent !important;\n}\n\n.react-phone-input-2 .flag {\n  box-shadow: none !important;\n}\n\n.react-tel-input .form-control {\n  font-size: 0.9vw !important;\n  font-family: Poppins, sans-serif !important;\n  font-weight: 500 !important;\n  background-color: transparent !important;\n  padding-left: 4vw !important;\n  height: 2vw !important;\n  color: white !important;\n  transform: translateY(-20%);\n}\n\n.react-tel-input .flag-dropdown {\n  background-color: transparent !important;\n}\n.react-tel-input {\n  border: none;\n}\n\n/* .custom-flag-button {\n  background-color: transparent !important;\n  border: none !important;\n  margin-left: 0.4vw;\n}\n\n.custom-prefix {\n  position: absolute;\n  top: 50%;\n  left: 1vw;\n  transform: translateY(-50%);\n  font-size: 0.9vw;\n  font-family: Poppins;\n  font-weight: 500;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  gap: 0.3vw;\n  pointer-events: none;\n}\n\n.custom-prefix .pipe {\n  margin-left: 0.3vw;\n  margin-right: 0.3vw;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
